import { immerable } from 'immer'
import { Node } from '../../entities'
import type { TreeNodeData } from '../../types'
import type { TreeGraph } from '../tree-graph'

export class TreeNode extends Node {
  [immerable] = true

  graph: TreeGraph
  side?: 'left' | 'right'
  width: number
  height: number
  vgap?: number
  hgap?: number
  size: NonNullable<TreeNodeData['size']>
  collapsed?: boolean
  depth?: number
  children?: TreeNodeData['children'];
  [key: string]: unknown

  constructor(graph: TreeGraph, nodeData: TreeNodeData) {
    super(graph, nodeData)

    this.id = nodeData.id
    this.graph = graph
    this.label = nodeData.label
    this.size = nodeData.size ?? [120, 30]
    this.width = nodeData.width ?? 120
    this.height = nodeData.height ?? 30
    this.type = nodeData.type
    this.data = nodeData.data
    this.children = nodeData.children
    this.collapsed = nodeData.collapsed
    this.depth = nodeData.depth
    this.side = nodeData.side
  }
}
